<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">{{ title }}</h5>
</div>
<div class="modal-body container" ngbAutofocus>
  <div *ngIf="data == null || data.length === 0">
    <p class="noData">No Product Identifiers found</p>
  </div>

  <div *ngIf="data.length > 0">
    <div class="row">
      <div class="col">
        <label>Type</label>
      </div>
      <div class="col">
        <label>Code</label>
      </div>
    </div>

    <div class="row" *ngFor="let product of data">
      <div class="col">
        <p>{{ product.typeProdIdentifiers }}</p>
      </div>
      <div class="col">
        <p>{{ product.codeProdIdentifiers }}</p>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-right">
<!--  <button-->
<!--    *ngIf="canReallocate"-->
<!--    type="button"-->
<!--    class="btn btn-secondary btn-sm"-->
<!--    (click)="modal.close('reallocate')"-->
<!--  >-->
<!--    Reallocate Identifiers-->
<!--  </button>-->
  <button
    type="button"
    class="btn btn-secondary btn-sm"
    (click)="modal.close('close modal')"
  >
    Close
  </button>
</div>
